export function isVI (state){
    return state.subscriber.identification === '800198348'
}

export function isSager (state){
    return ['900598368', '890300918'].includes(state.subscriber.identification)
}

export function isBatericars (state){
    return ['900973544'].includes(state.subscriber.identification)
}

export function isEuromotor (state){
    return ['902048314'].includes(state.subscriber.identification)
}

export function isVW (state){
    return ['901666689'].includes(state.subscriber.identification)
}

export function isLugor (state){
    return ['900266427'].includes(state.subscriber.identification)
}


// WEBPACK FOOTER //
// ./src/modules/login/getters.js